/**
=========================================================
* Material Dashboard 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Grid from "@mui/material/Grid";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";

// Material Dashboard 2 React example components
import DashboardLayout from "UIComponents/LayoutContainers/DashboardLayout";
import DashboardNavbar from "UIComponents/Navbars/DashboardNavbar";
import Footer from "UIComponents/Footer";
import ProfileInfoCard from "UIComponents/Cards/InfoCards/ProfileInfoCard";
import InfoCard from "UIComponents/Cards/InfoCard";
// Data
import reportsLineChartData from "layouts/dashboard/data/reportsLineChartData";

// Dashboard components
import Projects from "layouts/dashboard/components/Projects";
// Images
import burceMars from "assets/images/bruce-mars.jpg";
import { useTranslation } from "react-i18next";
import MDTypography from "components/MDTypography";
import WorkspaceCard from "UIComponents/Cards/InfoCards/WorkspaceCard";
import DevicesOverview from "./components/DevicesOverview";
//icons
import { ReactComponent as DescIcon } from "assets/images/icons/desc.svg";
import { ReactComponent as EmailIcon } from "assets/images/icons/email.svg";
function Dashboard() {
  const { t } = useTranslation();
  return (

    <DashboardLayout>
      <MDBox py={3}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox mb={1.5} sx={{ height: "80%" }}>
              <ProfileInfoCard
                avatar={burceMars}
                title='تست تستی'
                description='پنل کاربری'
                info={[
                  { label: "شماره همراه : ", value: "0921345657",icon:<DescIcon style={{marginRight:'8px'}}/>  },
                  { label: "ایمیل", value: "-",icon:<EmailIcon style={{marginRight:'8px'}} /> },
              
                ]}
        
              />
            </MDBox>
          </Grid>
          <Grid item xs={12} md={6} lg={6}>
            <MDBox mb={1.5} sx={{ height: "80%" }}>
              <InfoCard
                title={t("headings.arshId")}
                description={`لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ، و با استفاده از طراحان گرافیک
        است، چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است، و برای شرایط فعلی
        تکنولوژی مورد نیاز`}
              />
            </MDBox>
          </Grid>
        </Grid>
        <MDBox >
        <MDTypography my={2} mt={1} fontWeight="bold" >
          &nbsp;{t('headings.workspace')}
        </MDTypography>
          <Grid container spacing={3} justifyContent='center'>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={3}>
              <WorkspaceCard
                    icon="account_balance"
                    title="هماهنگ"
                  />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={3}>
              <WorkspaceCard
                    icon="account_balance"
                    title="گنجه"
                  />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={3}>
              <WorkspaceCard
                    icon="account_balance"
                    title="سیماپ" 
                  />
              </MDBox>
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <MDBox mb={3}>
              <WorkspaceCard
                    icon="account_balance"
                    title="تلوبیون" 
                  />
              </MDBox>
            </Grid>
          </Grid>
        </MDBox>
        <MDBox>
          <Grid container>
            <Grid item lg={12} xs={12} md={12}>
              <DevicesOverview />
            </Grid>
          </Grid>
        </MDBox>
      </MDBox>
      </DashboardLayout>
  );
}

export default Dashboard;
